/* eslint-disable camelcase */
import { createApp } from 'vue'
import { Modal } from 'ant-design-vue'
import App from './App.vue'
import router from './router/index'
import 'nprogress/nprogress.css'
import pinia from '@/store/store'
import 'vue-global-api'

import '@/assets/style/mian.scss'

const app = createApp(App)

app.use(router)

app.use(pinia)

app.use(Modal)

app.mount('#app')
